<div *ngIf="IsLoading" class="loader_cls">
  <div class="app-loader"></div>
</div>
<div class="policyquotescls">
    <div class="row">
        <div class="col-md-6">
            <h4 class="heading_search_policies" *ngIf="!IsCancelPolicy">Manage a Policy</h4>
            <h4 class="heading_search_policies" *ngIf="IsCancelPolicy">Cancel a Policy</h4>
        </div>
        <div class="col-md-6">
            <button style="float:right;margin-left: 15px;" name="DocumentBtn" id="DocumentBtnID"
                class="btn btn-small btn_create_policy_quotes mt-1" (click)="clickDocument()">
                <i name="DocumentBtnIcon" id="DocumentBtnIconID" class="fa fa-file"></i> &nbsp;
                Document Center
            </button>
            <button style="float:right" name="OnlineQuoteBtn" id="OnlineQuoteBtnID"
                class="btn btn-small btn_create_policy_quotes mt-1" (click)="CreateOnlineQuote()">
                <i name="OnlineQuoteIcon" id="OnlineQuoteIconID" class="fa fa-plus-circle"></i> &nbsp;
                Create New Online Quote
            </button>            
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-lg-12 col-md-12">
            <label name="searchPolicies" id="searchPoliciesID" class="label_cls">Search Policies</label>
            <div class="input-group search_policies" *ngIf="!IsBFMInternal">
                <span class="p-input-icon-right">
                    <i class="pi pi-search"></i>
                    <input autocomplete="off" type="text" class="globalfilter_bar global_search_wid" pInputText name="searchPoliciesFilter"
                        id="searchPoliciesFilterID" placeholder="Policy number or Insured's Name"
                        [(ngModel)]="PolicyorName" (input)="filterPolicy()" />
                </span>
            </div>
            <div class="input-group internalSearch" *ngIf="IsBFMInternal">
                <span class="p-input-icon-right" style="display: flex;">
                    <input autocomplete="off" type="text" class="globalfilter_bar global_search_wid" pInputText name="searchPoliciesFilter"
                        id="searchPoliciesFilterID" placeholder="Policy number or Insured's Name"
                        [(ngModel)]="PolicyorName" />
                    <button name="SearchBtn" id="ButtonSearchID"
                        class="btn-small btn_create_policy_quotes btn_search" (click)="searchForPolicy()">
                        <i name="SearchBtnIcon" id="ButtonBtnIconID" class="fa fa-search"></i> &nbsp;
                        Search
                    </button>
                </span>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 mt-2">
            <div id="accordion" class="accordion" *ngIf="filteredList.length>0" style="width: 100%;">
                <div class="card mb-0" [id]="'card' + i" *ngFor="let policy of filteredList; let i=index;">
                    <a class="card-header">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-2 col-md-2 col-12 policy_Accordian">
                                    {{policy?.nameInsured}}
                                </div>
                                <div class="col-lg-4 col-md-4 col-12 policy_Accordian">
                                    {{policy?.jobSiteAddress}}
                                </div>
                                <div class="col-lg-3 col-md-3 col-12 policy_Accordian">
                                    <span class="label_cls">Pol Eff: </span>{{policy?.effectiveDate |
                                    date:'MM/dd/yyyy'}} - {{policy?.expireDate | date:'MM/dd/yyyy'}}
                                </div>
                                <div class="col-lg-3" pTooltip="{{ IsCancelPolicy && policy?.status=='PendingCancellation' ? 'Pending BFM action' : '' }}">
                                    <button *ngIf="!IsCancelPolicy" title="Policy Change Request" style="float:right"
                                        name="OnlineQuoteBtn" id="OnlineQuoteBtnID"
                                        class="btn btn-small btn_create_policy_quotes ml-2"
                                        (click)="policyChangeRequest(policy,i,'btnclick')">
                                        Policy Change Request
                                    </button>
                                    <button *ngIf="IsCancelPolicy" name="cancelPolicy" id="cancelPolicyID"
                                        class="btn btn-small btn_create_policy_quotes {{ policy?.status == 'PendingCancellation' ? 'bpmicanelcls' : '' }} {{ statusChecks.includes(policy?.status.toUpperCase()) ? 'acc_policy_btn_disabled' : 'acc_policy_btn' }}"
                                        (click)="cancelPolicy(policy,i)" type="button" [disabled]="statusChecks.includes(policy?.status.toUpperCase()) || policy?.isGenesysPolicy"
                                        [pTooltip]="policy?.isGenesysPolicy ? 'Premium Bearing Endorsements are not available for this Policy' : ''" tooltipPosition="top">
                                        Cancel Policy
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div style="padding: 5px 12px;">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="row">
                                        <div class="col-lg-2 col-md-3 col-12 policy_num pr-0 policy_Accordian">
                                            <span *ngIf="policy?.nameInsured">{{policy?.productName}}</span>
                                            <!-- <span *ngIf="policy?.policyNumber">{{policy?.policyNumber}}</span> -->
                                        </div>

                                        <div class="col-lg-4">
                                            <label><span name="billplan" id="billplanID"
                                                    class="label_cls">Policy#
                                                    :
                                                </span> {{policy?.policyNumber}}</label>
                                        </div>
                                        <div class="col-lg-3">
                                            <label><span name="totalpremium" id="totalpremiumID"
                                                    class="label_cls">Total Premium: </span> $
                                                {{policy?.summaryTotals?.brPremiumAmount}}</label>
                                        </div>
                                        <div class="col-lg-3 text-center" >
                                            <label class="row" style="justify-content: center;" ><span name="status" id="statusID"
                                                    class="label_cls">Status:
                                                </span> {{policy?.status}} <div style="margin-left: 5px;" *ngIf="(['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION'].includes(policy?.status.toUpperCase()))"> as of {{policy?.modifyDate | date:"MM/dd/yyyy"}}</div></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <app-cancel-policy-popup [policyReasons]="reasonDropdown" [policyDetails]="currentPolicy" [IsCancel]="IsCancel" [currentPolicy]="policyDetails" [cancelPopupDetails]="cancelPopupDetails"
        (pushCancelDetails)="pushCancelDetails($event)" *ngIf="showCancelPopup" (popupEvent)="popUpClose($event)">
    </app-cancel-policy-popup>
    <app-evidence-of-insurance [currentPolicyDetail]="policyDetails" [isShowEvidence]="isShowEvidence" [PolicyQuotesList]="PolicyQuotesList"
    (popupClose)="closeEvidence()" [tempPolicyList]="tempPolicyList" *ngIf="isFromManagePolicy && !isShowReportClaim" [isFromManagePolicy]="isFromManagePolicy">
    </app-evidence-of-insurance>
    <report-claim [currentPolicyDetail]="policyDetails" [currentPolicy]="tempCurrentPolicy" [isShowReportClaim]="isShowReportClaim" [PolicyQuotesList]="PolicyQuotesList"
        (popupClose)="closeReportClaim()" [tempPolicyList]="tempPolicyList" *ngIf="isFromManagePolicy && !isShowEvidence" [isFromManagePolicy]="isFromManagePolicy">
    </report-claim>
    <p-paginator name="paginator" id="paginatorID" class="gen-paginator-override mousePointer"
        *ngIf="filteredList.length>0" [rows]="10" [totalRecords]="PolicyQuotesList.length"
        (onPageChange)="paginate($event)"></p-paginator>


    <!-- Start Policy Change Request Modal -->
    <p-dialog header="" [(visible)]="policyChangeValue" [modal]="true" [baseZIndex]="1000" [draggable]="false"
        [resizable]="false">
        <ng-template pTemplate="header">
            <div class="row" style="width:80%">
                <div class="col-lg-6 col-md-6 col-12">
                    <span class="policyHeaderLbl">{{policyChangeModal?.nameInsured}}</span>
                </div>
                <div class="col-lg-4 col-md-4 col-12">
                    <span class="policyHeaderLbl mr-2" *ngIf="policyChangeModal?.nameInsured">{{policyChangeModal?.productName}}</span>
                </div>
                <div class="col-lg-2 col-md-2 col-12">
                    <span class="policyHeaderLbl" *ngIf="policyChangeModal?.policyNumber">{{policyChangeModal?.policyNumber}}</span>
                </div>
            </div>
        </ng-template>
        
        <!-- Genesys Warning -->
        <div *ngIf="policyChangeModal?.isGenesysPolicy"
            class="genesys-warning-popup">
            Premium Bearing Endorsements are not available for this Policy
        </div>

        <div class="row" style="margin-top: 10px;">
            <div class="col-lg-5">
                <div class="row">
                    <div class="col-lg-2 col-2">
                        <i class="fa fa-user policyIcon"></i>
                    </div>
                    <div class="col-lg-8 col-8">
                        <span class="policyHeading">{{policyRequestLabels?.namedInsured}} </span>
                        <span pTooltip="{{isBPMiFields?.NamedInsured?.isShow ? 'Pending BFM action' : ''}}" class="policyLbl {{isBPMiFields?.NamedInsured?.isShow ? 'bpmicls' : ''}}">{{policyDetails?.clientInfo?.insuredName}}</span><br>
                        <span class="policyHeading"
                            *ngIf="policyDetails?.clientInfo?.additionalInsured.length>0">Additional Named
                            Insured:</span><br>
                        <ul style="padding: 2px 19px;">
                            <li pTooltip="{{isBPMiFields['AdditionalNamedInsured' + insured?.id]?.isShow ? 'Pending BFM action' : ''}}" *ngFor="let insured of policyDetails?.clientInfo?.additionalInsured" class="policyLbl  {{isBPMiFields['AdditionalNamedInsured'+insured?.id]?.isShow ? 'bpmicls' : ''}}">
                                {{insured?.name}}<br>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-2 col-2 {{ checkCancelledExpired() }} {{tempCurrentPolicy?.isExceedsMaximumAllowedAmendment || isCancelExpired || IsPolicyEvent? 'editdisableIcls' : ''}}">
                        <i class="fa fa-pencil-square-o mousePointer policyEditIcon" title="Edit" (click)="EditNameInsured()"></i>
                    </div>
                </div>
                <hr style="margin-top: 10px!important;">
                <div class="row">
                    <div class="col-lg-2 col-2">
                        <i class="fa fa-home policyIcon"></i>
                    </div>
                    <div class="col-lg-8 col-8">
                        <span class="policyHeading">{{policyRequestLabels?.projectAddress}}</span><br>
                        <span pTooltip="{{isBPMiFields?.ProjectAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.ProjectAddress?.isShow ? 'bpmicls' : ''}} policyLbl">{{policyDetails?.clientInfo?.jobsiteAddress[0].addressNo}} </span>
                        <span pTooltip="{{isBPMiFields?.ProjectAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.ProjectAddress?.isShow ? 'bpmicls' : ''}} policyLbl">{{policyDetails?.clientInfo?.jobsiteAddress[0].addressLine1}}</span>
                        <span pTooltip="{{isBPMiFields?.ProjectAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.ProjectAddress?.isShow ? 'bpmicls' : ''}} policyLbl"
                            *ngIf="policyDetails?.clientInfo?.jobsiteAddress[0]?.addressLine2">{{policyDetails?.clientInfo?.jobsiteAddress[0]?.addressLine2}}</span>
                        <span pTooltip="{{isBPMiFields?.ProjectAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.ProjectAddress?.isShow ? 'bpmicls' : ''}} policyLbl"> {{policyDetails?.clientInfo?.jobsiteAddress[0].city}} </span>
                        <span pTooltip="{{isBPMiFields?.ProjectAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.ProjectAddress?.isShow ? 'bpmicls' : ''}} policyLbl">{{policyDetails?.clientInfo?.jobsiteAddress[0].state}}
                            {{policyDetails?.clientInfo?.jobsiteAddress[0].zip}}</span>
                    </div>
                    <div pTooltip="{{isBPMiFields?.ProjectAddress?.isShow ? 'Pending BFM action' : ''}}" class="col-lg-2 col-2 {{ checkCancelledExpired() }} {{isBPMiFields?.ProjectAddress?.isShow || tempCurrentPolicy?.isExceedsMaximumAllowedAmendment || isCancelExpired || IsPolicyEvent ? 'editdisableIcls' : ''}}">
                        <i class="fa fa-pencil-square-o mousePointer policyEditIcon" title="Edit" (click)="editProjectAddress()"></i>
                    </div>
                </div>
                <hr style="margin-top: 10px!important;">
                <div class="row">
                    <div class="col-lg-2 col-2">
                        <i class="fa fa-envelope policyIcon"></i>
                    </div>
                    <div class="col-lg-8 col-8">

                        <span class="policyHeading">{{policyRequestLabels?.mailingAddress}}</span><br>
                        <span pTooltip="{{isBPMiFields?.MaillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.MaillingAddress?.isShow ? 'bpmicls' : ''}} policyLbl">{{policyDetails?.clientInfo?.mailingAddress[0].addressNo}} </span>
                        <span pTooltip="{{isBPMiFields?.MaillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.MaillingAddress?.isShow ? 'bpmicls' : ''}} policyLbl">{{policyDetails?.clientInfo?.mailingAddress[0].addressLine1}}</span>
                        <span pTooltip="{{isBPMiFields?.MaillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.MaillingAddress?.isShow ? 'bpmicls' : ''}} policyLbl"
                            *ngIf="policyDetails?.clientInfo?.mailingAddress[0]?.addressLine2">{{policyDetails?.clientInfo?.mailingAddress[0]?.addressLine2}}</span>
                        <span pTooltip="{{isBPMiFields?.MaillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.MaillingAddress?.isShow ? 'bpmicls' : ''}} policyLbl"> {{policyDetails?.clientInfo?.mailingAddress[0].city}} </span>
                        <span pTooltip="{{isBPMiFields?.MaillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.MaillingAddress?.isShow ? 'bpmicls' : ''}} policyLbl">{{policyDetails?.clientInfo?.mailingAddress[0].state}}
                            {{policyDetails?.clientInfo?.mailingAddress[0].zip}}</span>
                    </div>
                    <div pTooltip="{{isBPMiFields?.MaillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="col-lg-2 col-2 {{ checkCancelledExpired() }} {{isBPMiFields?.MaillingAddress?.isShow || isCancelExpired ? 'editdisableIcls' : ''}}">
                        <i class="fa fa-pencil-square-o mousePointer policyEditIcon" title="Edit" (click)="editMailingAddress()"></i>
                    </div>
                </div>
                <hr style="margin-top: 10px!important;">
                <div class="row">
                    <div class="col-lg-2 col-2">
                        <i class="fa fa-money policyIcon"></i>
                    </div>
                    <div class="col-lg-8 col-8">
                        <span class="policyHeading">Billing Address</span><br>
                        <span pTooltip="{{isBPMiFields?.BillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.BillingAddress?.isShow ? 'bpmicls' : ''}} policyLbl">{{policyDetails?.clientInfo?.billingAddress[0].addressNo}} </span>
                        <span pTooltip="{{isBPMiFields?.BillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.BillingAddress?.isShow ? 'bpmicls' : ''}} policyLbl">{{policyDetails?.clientInfo?.billingAddress[0].addressLine1}}</span>
                        <span pTooltip="{{isBPMiFields?.BillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.BillingAddress?.isShow ? 'bpmicls' : ''}} policyLbl"
                            *ngIf="policyDetails?.clientInfo?.billingAddress[0]?.addressLine2">{{policyDetails?.clientInfo?.billingAddress[0]?.addressLine2}}</span>
                        <span pTooltip="{{isBPMiFields?.BillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.BillingAddress?.isShow ? 'bpmicls' : ''}} policyLbl"> {{policyDetails?.clientInfo?.billingAddress[0].city}} </span>
                        <span pTooltip="{{isBPMiFields?.BillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.BillingAddress?.isShow ? 'bpmicls' : ''}} policyLbl">{{policyDetails?.clientInfo?.billingAddress[0].state}}
                            {{policyDetails?.clientInfo?.billingAddress[0].zip}}</span>
                    </div>
                    <div *ngIf="policyDetails?.clientInfo?.billingOption != 'Agency Bill'" pTooltip="{{isBPMiFields?.BillingAddress?.isShow ? 'Pending BFM action' : ''}}" class="col-lg-2 col-2 {{ checkCancelledExpired() }} {{ isBPMiFields?.BillingAddress?.isShow || isCancelExpired ? 'editdisableIcls' : '' }}">
                        <i class="fa fa-pencil-square-o mousePointer policyEditIcon" title="Edit" (click)="editBillingAddress()"></i>
                    </div>
                </div>
                <hr style="margin-top: 10px!important;">
                <div class="row">
                    <div class="col-lg-2 col-2">
                        <i class="fa fa-university policyIcon"></i>
                    </div>
                    <div class="col-lg-8 col-8">

                        <span class="policyHeading">{{policyRequestLabels?.lossPayee}} </span><br>
                        <span *ngFor="let interest of policyDetails?.clientInfo?.financialInterest?.interestTypes">
                            <span pTooltip="{{(isBPMiFields['InsurableInterest'+interest?.interestID]?.isShow) ? 'Pending BFM action' : ''}}" class="{{(isBPMiFields['InsurableInterest'+interest?.interestID]?.isShow) ? 'bpmicls' : ''}} policyLbl" style="margin-left: 20px;">{{interest?.interestType}} :
                                <ul style="margin-left: 15px;margin-bottom: 0;">
                                    <li>
                                        {{interest?.businessName}}
                                    </li>
                                </ul>
                            </span>                            
                        </span>
                    </div>
                    <div class="col-lg-2 col-2 {{ checkCancelledExpired() }} {{ isCancelExpired ? 'editdisableIcls' : '' }}">
                        <i class="fa fa-pencil-square-o mousePointer policyEditIcon"
                        title="Edit" (click)="openFinancialInterest()"></i>
                    </div>
                </div>
                <hr style="margin-top: 10px!important;">
                <div class="row">
                    <div class="col-lg-2 col-2">
                        <i class="fa fa-address-card-o policyIcon"></i>
                    </div>
                    <div class="col-lg-8 col-8">
                        <span class="policyHeading">{{policyRequestLabels?.quotePackage?.blanketAdditionalInsured}} </span>
                        <br/>
                        <span pTooltip="{{isBPMiFields?.BlanketInsured?.isShow ? 'Pending BFM action' : ''}}" class="policyLbl {{isBPMiFields?.BlanketInsured?.isShow ? 'bpmicls' : ''}}">{{policyDetails?.clientInfo?.isBlanketInsured?.text}}</span>
                    </div>
                    <div pTooltip="{{isBPMiFields?.BlanketInsured?.isShow ? 'Pending BFM action' : ''}}"
                        class="col-lg-2 col-2 {{ checkCancelledExpired() }} {{ isBPMiFields?.BlanketInsured?.isShow || isCancelExpired || IsPolicyEvent ? 'editdisableIcls' : '' }}">
                        <i id="blanketEditBtn" class="fa fa-pencil-square-o mousePointer policyEditIcon" title="Edit"
                        (click)="EditBlanketAI()"></i>
                    </div>
                </div>
                <hr style="margin-top: 10px!important;">
            </div>
            <div class="col-lg-7">
                <div class="cardheading">
                    <span style="margin-left: 5px;">Policy Details</span>
                    <span class="row" style="float: right;margin-right: 5px;">Status: {{policyChangeModal?.status}} <div style="margin-left: 5px;" *ngIf="(['Canceled', 'Cancelled', 'PendingCancellation'].includes(policyChangeModal?.status))"> as of {{policyChangeModal?.modifyDate | date:"MM/dd/yyyy"}}</div></span>
                </div>
                <div class="policyCardHeader">
                    <div class="row" style="font-size: 13px;margin-top: 0.9rem!important;">
                        <div class="col-lg-6">
                            <div style="width:100%;float:left">
                                <span class="policyHeading">{{policyRequestLabels?.quotePackage?.policyEff}}</span>
                                <span class="policyLbl"> {{policyDetails?.policyStartDate |
                                    date:'MM/dd/yyyy'}} {{policyDetails?.policyEndDate?'-':''}}
                                    <span class="{{showExtendBPMi ? 'bpmicls' : ''}}" pTooltip="{{showExtendBPMi ? 'Pending BFM action' : ''}}">{{policyDetails?.policyEndDate | date:'MM/dd/yyyy'}}</span></span>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div style="width:100%;float:left">
                                <span class="policyHeading">{{policyRequestLabels?.quotePackage?.totalPremium}}</span>
                                <span class="policyLbl"> {{policyDetails?.premium}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="font-size: 13px;margin-top: 0.9rem!important;">
                        <div class="col-lg-6">
                            <div style="width:100%;float:left">
                                <span class="policyHeading">{{policyRequestLabels?.quotePackage?.billPlan}}</span>
                                <span class="policyLbl"> {{policyDetails?.clientInfo?.billingOption}}</span>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div style="width:100%;float:left">
                                <span class="policyHeading">{{policyRequestLabels?.quotePackage?.payPlan}} </span>
                                <span pTooltip="{{isBPMiFields?.BillingPayPlan?.isShow ? 'Pending BFM action' : ''}}" class="policyLbl {{isBPMiFields?.BillingPayPlan?.isShow ? 'bpmicls' : ''}}">{{policyDetails?.clientInfo?.paymentPlan}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="font-size: 13px;margin-top: 0.9rem!important;">
                        <div class="col-lg-6">
                            <div style="width:100%;float:left">
                                <span class="policyHeading">{{policyRequestLabels?.quotePackage?.coverageType}}</span>
                                <span class="policyLbl"> {{policyDetails?.coverageType}}</span>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div style="width:100%;float:left">
                                <span
                                    class="policyHeading">{{policyRequestLabels?.quotePackage?.constructionType}}</span>
                                <span class="policyLbl"> {{policyDetails?.constructionType}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="font-size: 13px;margin-top: 0.9rem!important;">
                        <div class="col-lg-6">
                            <div style="width:100%;float:left">
                                <span class="policyHeading">{{policyRequestLabels?.quotePackage?.occupancyType}}</span>
                                <span class="policyLbl"> {{policyDetails?.occupancyType}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="policyCardBody">
                    <div class="row">
                        <div class="col-lg-10">
                            <div class="row" style="margin-top: .50rem!important;">
                                <div class="col-lg-6">
                                    <div style="width:100%;float:left">
                                        <span class="policyHeading">{{policyRequestLabels?.quotePackage?.projectLimit}}</span>
                                        <span pTooltip="{{isBPMiFields?.ProjectLimit?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.ProjectLimit?.isShow ? 'bpmicls' : ''}} policyLbl"> {{policyDetails?.policyDetails?.jobsiteLimit}}</span>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div style="width:100%;float:left">
                                        <span class="policyHeading">{{policyRequestLabels?.quotePackage?.deductible}}</span>
                                        <span pTooltip="{{isBPMiFields?.Deductible?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.Deductible?.isShow ? 'bpmicls' : ''}} policyLbl"> {{policyDetails?.policyDetails?.deductible}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="font-size: 13px;margin-top: 1.8rem!important;">
                                <div class="col-lg-6" *ngIf="policyDetails?.policyDetails?.flood?.limit != 0">
                                    <div style="width:100%;float:left">
                                        <span class="policyHeading">{{policyRequestLabels?.quotePackage?.floodLimit}}</span>
                                        <span pTooltip="{{isBPMiFields?.FloodLimit?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.FloodLimit?.isShow ? 'bpmicls' : ''}} policyLbl"> {{policyDetails?.policyDetails?.flood?.limit}}</span>
                                    </div>
                                </div>
                                <div class="col-lg-6" *ngIf="policyDetails?.policyDetails?.earthQuake?.limit != 0">
                                    <div style="width:100%;float:left">
                                        <span class="policyHeading">{{policyRequestLabels?.quotePackage?.earthquakeLimit}}</span>
                                        <span pTooltip="{{isBPMiFields?.EarthQuakeLimit?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.EarthQuakeLimit?.isShow ? 'bpmicls' : ''}} policyLbl"> {{policyDetails?.policyDetails?.earthQuake?.limit}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="row {{ checkCancelledExpired() }} {{ isCancelExpired || IsPolicyEvent ||  policyChangeModal?.isGenesysPolicy ? 'editdisableIcls' : '' }}" style="padding: 18px 36px;">
                                <i class="fa fa-pencil-square-o mousePointer policyEditIcon" title="Edit" style="margin-top: 1rem;" (click)="editPolicyDetails()"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 mt-3">
                        <span class="pop_label label_cls mb-2">Policy Options: </span>
                        <br>
                        <div class="row" style="margin-left: -10px;">
                            <div class="mt-2" *ngFor="let option of PolicyOptions">
                                <span *ngIf="option=='Report a Claim'" class="policyEditIcon">
                                    <button name="Reportoptionbtn" id="ReportoptionbtnID" title="{{option}}"
                                    (click)="openReportClaim(tempCurrentPolicy)" class="btn btn-small btn_create_policy_quotes policybtns ml-2">
                                        {{option}}
                                    </button>
                                </span>
                                <span *ngIf="option=='Request Evidence of Insurance'" class="{{ checkCancelledExpired() }}">
                                    <button name="Evidenceoptionbtn" id="EvidenceoptionbtnID" title="{{option}}"  [disabled]="isCancelExpired||tempCurrentPolicy?.isExceedsMaximumAllowedAmendment||this.statusChecks.includes(this.policyChangeModal?.status.toUpperCase())?true:false"
                                        (click)="openEvidence()" class="btn btn-small btn_create_policy_quotes policybtns ml-2 ">
                                        {{option}}
                                    </button>
                                </span>
                                <span *ngIf="option=='Extend Policy'" pTooltip="{{(canAmendData?.extendPolicyTerm == false && isBPMiFields?.ExpirationDate?.isShow) ? 'Only one extension allowed and Pending BFM action' : canAmendData?.extendPolicyTerm == false ? 'Only one extension allowed' : isBPMiFields?.ExpirationDate?.isShow ? 'Pending BFM action' : ''}}" class="{{ statusChecks.includes(policyChangeModal?.status.toUpperCase()) || canAmendData?.extendPolicyTerm == false ? 'policyDisableEditIcon' : 'policyEditIcon' }}">
                                    <button name="optionbtn" id="optionbtnID" title="{{option}}" [disabled]="!tempCurrentPolicy?.canExtend || statusChecks.includes(policyChangeModal?.status.toUpperCase()) || isBPMiFields?.ExpirationDate?.isShow || canAmendData?.extendPolicyTerm == false || IsPolicyEvent || !IsPolicyExtensionEnable || policyChangeModal?.isGenesysPolicy"
                                        (click)="showQuestionPage()" class="btn btn-small btn_create_policy_quotes policybtns ml-2">
                                        {{option}}
                                    </button>
                                </span>
                                <span *ngIf="option=='Cancel Policy'" pTooltip="{{isBPMiFields?.Cancellation?.isShow ? 'Pending BFM action' : ''}}" class="{{ checkCancelledExpired() }}">
                                    <button name="optionbtn" id="optionbtnID" title="{{option}}" [disabled]="isCancelExpired || statusChecks.includes(policyChangeModal?.status.toUpperCase()) || isBPMiFields?.Cancellation?.isShow || policyChangeModal?.isGenesysPolicy"
                                        (click)="cancelPolicy(tempCurrentPolicy)" class="{{isBPMiFields?.Cancellation?.isShow ? 'bpmicanelcls' : ''}} btn btn-small btn_create_policy_quotes policybtns ml-2">
                                        {{option}}
                                    </button>
                                </span>
                                <span *ngIf="(option=='Edit Pay Plan' || option=='Change Pay Plan') && policyDetails?.clientInfo?.billingOption != 'Agency Bill'" pTooltip="{{isBPMiFields?.BillingPayPlan?.isShow ? 'Pending BFM action' : ''}}" class="{{ checkCancelledExpired() }}">
                                    <button name="optionbtn" id="optionbtnID" title="{{option}}" [disabled]="isCancelExpired || statusChecks.includes(policyChangeModal?.status.toUpperCase()) || isBPMiFields?.BillingPayPlan?.isShow || IsPolicyEvent"
                                        (click)="EditPayPlan()" class="btn btn-small btn_create_policy_quotes policybtns ml-2">
                                        {{option}}
                                    </button>
                                </span>
                                <span *ngIf="option=='View Policy Documents'" class="policyEditIcon">
                                    <button name="optionbtn" id="optionbtnID" title="{{option}}" (click)="openAgentPortal()" class="btn btn-small btn_create_policy_quotes policybtns ml-2">
                                        {{option}}
                                    </button>
                                </span>
                                <span *ngIf="option!='Report a Claim' && option!='View Policy Documents' && option!='Extend Policy' && option!='Cancel Policy' && option!='Edit Pay Plan' && option!='Change Pay Plan' && option!='Request Evidence of Insurance'" class="{{ checkCancelledExpired() }}">
                                    <button name="optionbtn" id="optionbtnID" title="{{option}}" class="btn btn-small btn_create_policy_quotes policybtns ml-2">
                                        {{option}}
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>            
        </div>
        <div class="row float-right">
            <div class="col-lg-12">
                <button name="EditCard" id="EditCardID" class="policyCloseBtn" (click)="policyChangeValue=false;"
                type="button">{{policyRequestLabels?.closeBtn}}</button>
            </div>
        </div>
        <div *ngIf="IsPolicyEvent==true" style="bottom: 0; margin-top: 38px">
            <h6 style="text-align: center; color: red !important;">Managing this policy is currently unavailable due to its location and {{this.eventReason}}.</h6>
        </div>
        
    </p-dialog>
    <!-- End Policy Request Change Modal-->
    <p-dialog header="Edit Name Insured - {{policyChangeModal?.policyNumber}}" (onHide)="closeNameInsured()"
        styleClass="EditPolicy" [(visible)]="EditPolicy" [modal]="true" [style]="{width: '50vw !important'}"
        [baseZIndex]="1000" [draggable]="false" [resizable]="false" [closable]="true">
        <div class="">
            <div class="row mt-4">
                <div class="col-lg-5">
                    <label class="policyHeading">{{policyRequestLabels?.editNamedInsuredScreenLabels?.primaryNamedLbl}}</label>
                </div>
                <div class="col-lg-7">
                    <div class="row">
                        <input type="text" class="form-control mousePointer insured_control" [disabled]="DisableNameInsured || isBPMiFields?.NamedInsured?.isShow"
                            name="primaryNamed" id="primaryNamedID" [(ngModel)]="NameInsuredValue"
                            placeholder="Enter Primary Named" (input)="ValidateNameInsured()" />
                        <span *ngIf="ShowNameUndo" class="{{isBPMiFields?.NamedInsured?.isShow ? 'editdisableIcls' : ''}}">
                            <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoNameInsured()"></i>
                        </span>
                        <span *ngIf="!ShowNameUndo" pTooltip="{{isBPMiFields?.NamedInsured?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.NamedInsured?.isShow ? 'editdisableIcls' : ''}}">
                            <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="NameInsuredEdit()"></i>
                        </span>
                        <span *ngIf="NameInsuredError" style="font-size: 13px;color:red">Named Insured is
                            required</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-2">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row mt-1" *ngFor="let Insured of  AdditionalInsuredList; let i=index">
                        <div class="col-lg-5">
                            <label *ngIf="i==0" class="policyHeading">{{policyRequestLabels?.editNamedInsuredScreenLabels?.additionalNamedInsuredLbl}}</label>
                        </div>
                        <div class="col-lg-7">
                            <div class="row">
                                <input type="text" class="form-control mousePointer insured_control" [disabled]="Insured.Disabled"
                                    name="'additionalNameInsured' + i" [id]="'additionalNameInsuredID' + i"
                                    [(ngModel)]="Insured.answer"
                                    [ngClass]="{ 'is-invalid': Insured.showErrorMsg}"
                                    placeholder="Enter Additional Named Insured"
                                    (input)="ValidateAdditionalName($event,i);" />
                                <span *ngIf="!Insured.showUndo">
                                    <i class="fa fa-trash-o mousePointer del_icon {{(isBPMiFields['AdditionalNamedInsured'+Insured?.id]?.isShow && Insured?.previousValue != null  && Insured?.previousValue != '') ? 'editdisableIcls' : ''}}" title="Delete"
                                        (click)="DeleteAdditionalInsured(i);Insured.showUndo=true;"></i>
                                    <i pTooltip="{{isBPMiFields['AdditionalNamedInsured'+insured?.id]?.isShow ? 'Pending BFM action' : ''}}" class="fa fa-pencil-square-o mousePointer edit_icon {{(isBPMiFields['AdditionalNamedInsured'+Insured?.id]?.isShow && Insured?.previousValue != null && Insured?.previousValue != '') ? 'editdisableIcls' : ''}}" title="Edit"
                                        (click)="EditAdditionalInsured(i);"></i>
                                </span>
                                <span *ngIf="Insured.showUndo">
                                    <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoNameAdditionalInsured(i)"></i>
                                </span>
                                <span *ngIf="Insured.showErrorMsg" style="font-size: 13px;color:red">Additional Named
                                    Insured is required</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="showAddInsured" style="margin-top: 17px;margin-bottom: -8px;">
            <div class="col-lg-12">
                <a class="mousePointer addInsuredLnk"
                    (click)="onAddNameInsured()">{{policyRequestLabels?.editNamedInsuredScreenLabels?.clickToAddInsuredLnk}}</a>
            </div>
        </div>
        <!-- <div class="color-box space">
            <div class="info-tab tip-icon" title="Useful Tips"><i></i></div>
            <div class="tip-box">
                <p><strong>Info:</strong>*By clicking Submit Change you are amending the policy information</p>
            </div>
        </div> -->
        <div class="row mt-2">
            <div class="checkbox m-0">
                <input name="isConfirmBPMi" type='checkbox' id="isConfirmBPMiID" [checked]="isConfirmBPMi" [(ngModel)]="isConfirmBPMiChange"
                (change)="isConfirmBPMi = !isConfirmBPMi" />
                <label name="isConfirmBPMi_lbl" style="font-size: 15px;color: black;font-style: italic;" id="isConfirmBPMilbl" for="isConfirmBPMiID">
                I, as the undersigned representative of the named insured, agree that the insured has no knowledge of any pending claim, loss, or any circumstances based upon which it would be reasonable to conclude that a claim may result.
                </label>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-lg-12 text-right form-group">
                <button class="SubmitBtn mt-3" 
                    (click)="UpdateNameInsured()" [disabled]="!isConfirmBPMiChange || DisableNameValues()">{{policyRequestLabels?.editNamedInsuredScreenLabels?.updatePolicyBtn}}</button>
            </div>
        </div>        
        <div class="row mt-2 mb-0">
            <div class="col-lg-12">
                <span class="projectInfo_text">*By clicking Submit Change you are amending the policy information</span>
            </div>
        </div>
    </p-dialog>
    <p-dialog header="Edit Project Address - {{policyChangeModal?.policyNumber}}" (onHide)="closeProjectAddress()"
        styleClass="EditMailingPopUp" [(visible)]="EditProject" [modal]="true" [style]="{width: '50vw !important'}"
        [baseZIndex]="1000" [draggable]="false" [resizable]="false" [closable]="true">
        <form  (ngSubmit)="UpdateProjectAddress();" #projectform="ngForm">
            <div class="form-group">
                <div class="row" style="margin-top: 10px;">
                    <div class="col-lg-3">
                        <label class="policyHeading">Address</label>
                    </div>
                    <div class="col-lg-9">
                        <!-- <div class="row">
                            <input type="text" class="form-control address_controls" [(ngModel)]="ProjectAddressInfo.streetNo" id="ProaddressNo" required
                            [ngModelOptions]="{standalone: true}" name="ProaddressNo" placeholder="Street No" [disabled]="!ProjectAddressInfo.isAddressNoEdit" #ProaddressNo="ngModel"/>
                            <span *ngIf="!ProjectAddressInfo.isAddressNoEdit">
                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="ProjectAddressInfo.isAddressNoEdit=!ProjectAddressInfo.isAddressNoEdit;"></i>
                            </span>
                            <span *ngIf="ProjectAddressInfo.isAddressNoEdit">
                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoProjectAddress('addressNo');ProjectAddressInfo.isAddressNoEdit=!ProjectAddressInfo.isAddressNoEdit"></i>
                            </span>                            
                        </div>
                        <div *ngIf="projectform.submitted && (ProjectAddressInfo.streetNo == '' || ProjectAddressInfo.streetNo == null)" style="margin-left: -15px;color: red;">
                            <div>Street No is required</div>
                        </div>   -->
                        <div class="row" style="margin-top:10px;">
                            <input type="text" class="form-control address_controls" name="projectaddress1" placeholder="Address" required [disabled]="!ProjectAddressInfo.isAddress1Edit"
                            [(ngModel)]="ProjectAddressInfo.address1" #projectaddress1="ngModel" [ngModelOptions]="{standalone: true}" maxlength="40"/>
                            <span *ngIf="!ProjectAddressInfo.isAddress1Edit">
                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="ProjectAddressInfo.isAddress1Edit=!ProjectAddressInfo.isAddress1Edit;"></i>
                            </span>
                            <span *ngIf="ProjectAddressInfo.isAddress1Edit">
                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoProjectAddress('address1');ProjectAddressInfo.isAddress1Edit=!ProjectAddressInfo.isAddress1Edit"></i>
                            </span>                            
                        </div>
                        <div *ngIf="projectform.submitted && (ProjectAddressInfo.address1 == '' || ProjectAddressInfo.address1 == null)" style="margin-left: -15px;color: red;">
                            <div>Address is required</div>
                        </div> 
                        <div class="row" style="margin-top:10px;">
                            <input type="text" class="form-control address_controls" name="projectcity" disabled
                            [(ngModel)]="ProjectAddressInfo.city" #projectcity="ngModel" [ngModelOptions]="{standalone: true}" placeholder="City" />                            
                        </div>
                        <div class="row" style="margin-top:10px;">
                            <input type="text" class="form-control address_controls" name="projectstate" disabled
                            [(ngModel)]="ProjectAddressInfo.state" #projectstate="ngModel" [ngModelOptions]="{standalone: true}" placeholder="State" />
                        </div>
                        <div class="row" style="margin-top:10px;">
                            <p-inputNumber class="zipCode_popup" placeholder="ZIP CODE" disabled
                            [(ngModel)]="ProjectAddressInfo.zip" #projectzip="ngModel" [ngModelOptions]="{standalone: true}" name="Zip1" [maxlength]="5"
                                [useGrouping]="false"></p-inputNumber>                            
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="checkbox m-0">
                        <input name="isConfirmBPMi" type='checkbox' id="isConfirmBPMiID" [checked]="isConfirmBPMi" [(ngModel)]="isConfirmBPMiChange"
                        (change)="isConfirmBPMi = !isConfirmBPMi" />
                        <label name="isConfirmBPMi_lbl" style="font-size: 15px;color: black;font-style: italic;" id="isConfirmBPMilbl" for="isConfirmBPMiID">
                        I, as the undersigned representative of the named insured, agree that the insured has no knowledge of any pending claim, loss, or any circumstances based upon which it would be reasonable to conclude that a claim may result.
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group" style="margin-top: 1.7rem;margin-bottom: 0;
                        float: right;">
                            <button [disabled]="!isConfirmBPMiChange || isProjectSubmitDisabled()" class="SubmitBtn">Submit Change</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </p-dialog>
    <p-dialog header="Edit Mailing Address - {{policyChangeModal?.policyNumber}}" (onHide)="closeMailingAddress()"
        styleClass="EditMailingPopUp" [(visible)]="EditMailing" [modal]="true" [style]="{width: '50vw !important'}"
        [baseZIndex]="1000" [draggable]="false" [resizable]="false" [closable]="true">
        <div class="form-group mb-0">
            <div class="row" style="margin-top: 10px;">
                <div class="col-lg-3">
                    <label class="policyHeading">Address</label>
                </div>
                <div class="col-lg-9">
                    <div class="row">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" value="ProjectAddress"
                                [(ngModel)]="MailingType" id="flexRadioDefault1"
                                (click)="ShowEditMailView=false;UseProjectAddress();">
                            <label class="form-check-label mailingLabel" for="flexRadioDefault1">
                                Use Project Address
                            </label><br>
                            <span style="margin-top:5px;color:#0092c9">{{autocompleteInput?autocompleteInput:''}}</span>
                        </div>
                    </div>
                    <div class="row" style="margin-top:10px;">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault"
                                value="NewMailingAddress" [(ngModel)]="MailingType" id="flexRadioDefault2"
                                (click)="UpdateMailingAddress();">
                            <label class="form-check-label mailingLabel" for="flexRadioDefault2">
                                Update Mailing Address
                            </label>
                        </div>
                    </div>
                    <div class="row mt-3" *ngIf="MailingType=='NewMailingAddress'">
                        <div class="col-lg-12">
                            <form (ngSubmit)="mailform.valid && AddNewMailAddress();" #mailform="ngForm">
                                <div class="form-group">
                                    <!-- <div class="row">
                                        <input type="text" class="form-control address_controls" [(ngModel)]="MailingForm.streetNo" id="StreetNO" required
                                            [ngClass]="{ 'is-invalid': mailform.submitted && !addNumber.valid && addNumber.status !='DISABLED' }" name="addNo" [disabled]="MailEdit.showstreetNo"
                                            #addNumber="ngModel"/>
                                            <span  *ngIf="MailEdit.showstreetNo">
                                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('StreetNO');MailEdit.showstreetNo=false;"></i>
                                            </span>
                                            <span *ngIf="!MailEdit.showstreetNo">
                                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="undoMailEdit('streetNo')"></i>
                                            </span>
                                        <div *ngIf="mailform.submitted && !addNumber.valid && addNumber.status !='DISABLED'" class="invalid-feedback">
                                            <div>Address Number is required</div>
                                        </div>
                                    </div> -->
                                    <div class="row" style="margin-top:10px;">
                                        <input type="text" class="form-control address_controls" [(ngModel)]="MailingForm.address1" id="address1" required
                                            [ngClass]="{ 'is-invalid': mailform.submitted && !address1.valid && address1.status !='DISABLED' }" name="address1" [disabled]="MailEdit.showaddress1"
                                            #address1="ngModel" maxlength="40"/>
                                        <!-- <textarea [(ngModel)]="MailingForm.address1" class="form-control address_controls" required
                                            [ngClass]="{ 'is-invalid': mailform.submitted && !address1.valid && address1.status !='DISABLED' }" name="address" [disabled]="MailEdit.showaddress1"
                                            id="Add1" #address1="ngModel"></textarea> -->
                                            <span  *ngIf="MailEdit.showaddress1">
                                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('Add1');MailEdit.showaddress1=false;"></i>
                                            </span>
                                            <span *ngIf="!MailEdit.showaddress1">
                                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="undoMailEdit('address1')"></i>
                                            </span>
                                        <div *ngIf="mailform.submitted && !address1.valid && address1.status !='DISABLED'" class="invalid-feedback">
                                            <div>Address is required</div>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top:10px;">
                                        <input type="text" class="form-control address_controls" [(ngModel)]="MailingForm.city" id="cityID" required
                                            [ngClass]="{ 'is-invalid': mailform.submitted && !city.valid && city.status !='DISABLED' }" name="city" [disabled]="MailEdit.showcity"
                                            #city="ngModel"/>
                                            <span  *ngIf="MailEdit.showcity">
                                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('cityID');MailEdit.showcity=false;"></i>
                                            </span>
                                            <span *ngIf="!MailEdit.showcity">
                                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="undoMailEdit('city')"></i>
                                            </span>
                                        <div *ngIf="mailform.submitted && !city.valid && city.status !='DISABLED'" class="invalid-feedback">
                                            <div>City is required</div>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top:10px;">
                                        <p-dropdown [options]="stateList"  class="stateDropdown padding_10" [(ngModel)]="MailingForm.state" required
                                        [ngClass]="{ 'is-invalid': mailform.submitted && !state.valid && state.status !='DISABLED' }" name="state" [disabled]="MailEdit.showstate"
                                        optionLabel="label" optionValue="code" inputId="stateID" #state="ngModel"></p-dropdown>
                                        <span  *ngIf="MailEdit.showstate">
                                            <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('stateID');MailEdit.showstate=false;"></i>
                                        </span>
                                        <span *ngIf="!MailEdit.showstate">
                                            <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="undoMailEdit('state')"></i>
                                        </span>    
                                        <div *ngIf="mailform.submitted && !state.valid && state.status !='DISABLED'" class="invalid-feedback">
                                            <div>State is required</div>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top:10px;">
                                        <p-inputNumber class="zipCode_popup" inputId="zipID" required
                                            [ngClass]="{ 'is-invalid': mailform.submitted && !zip.valid && zip.status !='DISABLED' }" name="Zip" [disabled]="MailEdit.showpostalCode"
                                            [maxlength]="5" [useGrouping]="false" [(ngModel)]="MailingForm.postalCode" #zip="ngModel">
                                        </p-inputNumber>
                                        <span  *ngIf="MailEdit.showpostalCode">
                                            <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('zipID');MailEdit.showpostalCode=false;"></i>
                                        </span>
                                        <span *ngIf="!MailEdit.showpostalCode">
                                            <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="undoMailEdit('postalCode')"></i>
                                        </span>
                                        <div *ngIf="mailform.submitted && !zip.valid && zip.status !='DISABLED'" class="invalid-feedback">
                                            <div>Zip is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row float-right mt-2">
                                    <div class="form-group mb-0">
                                        <button class="SubmitBtn" [disabled]="validateMailUpdate()">Submit Change</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="row mt-3 float-right" *ngIf="MailingType!='NewMailingAddress'">
                        <button class="SubmitBtn" (click)="AddNewMailAddress();">Submit Change</button>
                    </div>
                </div>
            </div>
            <div class="row mt-3 mb-0">
                <div class="col-lg-12">
                    <span class="projectInfo_text">*By clicking Submit Change you are amending the policy information</span>
                </div>
            </div>
        </div>
    </p-dialog>
    <!-- <p-dialog header="Overwrite Address" (onHide)="form.reset({}); submitted = false;OnErrorAddress=false;"
        styleClass="EditMailingPopUp OverWriteAddressPopUp" [(visible)]="OnErrorAddress" [modal]="true"
        [style]="{width: '50vw !important'}" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
        [closable]="true">
        <form [formGroup]="OverWriteForm" (ngSubmit)="OverWriteSubmit(form);" #form="ngForm">
            <div class="row" style="margin-top: 15px;">
                <div class="col-lg-12">
                    <p style="font-weight: 600;font-size: 14px;">Invalid address by Google. Enter address here for
                        quotes and click Yes.
                        Click No to enter correct address in Google</p>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-lg-6">
                        <label class="poplblcls">Street</label>
                        <p-inputNumber name="Street" class="zipCode" placeholder="Enter Street" formControlName="streetValue"
                            [maxlength]="5" [useGrouping]="false"></p-inputNumber>
                    </div>
                    <div class="col-lg-6">
                        <label class="poplblcls">Street Name</label><span style="color:red;margin-left: 5px;">*</span>
                        <input type="text" formControlName="streetName" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.streetName.errors }"
                            placeholder="Enter Street Name" />
                        <div *ngIf="submitted && f.streetName.errors" class="invalid-feedback">
                            <div *ngIf="f.streetName.errors.required">Street Name is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group mt-2">
                <div class="row">
                    <div class="col-lg-6">
                        <label class="poplblcls">City</label><span style="color:red;margin-left:10px;">*</span>
                        <input type="text" class="form-control" formControlName="city"
                            [ngClass]="{ 'is-invalid': submitted && f.city.errors }" placeholder="Enter City" />
                        <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                            <div *ngIf="f.city.errors.required">City is required</div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <label class="poplblcls">State</label><span style="color:red;margin-left:10px">*</span>
                        <input type="text" class="form-control" formControlName="state"
                            [ngClass]="{ 'is-invalid': submitted && f.state.errors }" placeholder="Enter State" />
                        <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                            <div *ngIf="f.state.errors.required">State is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group mt-2">
                <div class="row">
                    <div class="col-lg-6">
                        <label class="poplblcls">Zip</label><span style="color:red;margin-left:10px;">*</span>
                        <p-inputNumber class="form-control zipCode" placeholder="Enter Zip"
                            [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" name="Zip1" [maxlength]="5"
                            [useGrouping]="false" formControlName="zip"></p-inputNumber>
                        <div *ngIf="submitted && f.zip.errors" class="invalid-feedback">
                            <div *ngIf="f.zip.errors.required">Zip is required</div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group" style="margin-top: 1.7rem;
                        float: right;">
                            <button class="btn btn-primary">Yes</button>
                            <button class="btn btn-primary ml-3" style="margin-right: 15px;height: 2.4rem;"
                                (click)="form.reset({}); submitted = false;ProjectAddressValue=null;OnErrorAddress=false;">No</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </p-dialog> -->
    <p-dialog header="Edit Policy Details - {{policyChangeModal?.policyNumber}}" (onHide)="closeEditPolicy();"
        styleClass="EditMailingPopUp OverWriteAddressPopUp PolicyDetailsPopup" [(visible)]="onEditPolicy" [modal]="true"
        [style]="{width: '50vw !important'}" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
        [closable]="true">
        <form (ngSubmit)="policy.valid && PolicyDetailsSubmit();" #policy="ngForm">
            <div class="form-group">
                <div class="row mt-2">
                    <div class="col-lg-12">
                        <label class="policyHeading">Project Limit</label><br>
                        <p-inputNumber name="projectlimit" class="productinfo" [(ngModel)]="ProjectLimitValue" inputId="projectID"
                            placeholder="Enter Project Limit"  [max]="policyDetails?.jobSiteOptionLimits?.jobSiteMaxLimit" #projectLimit="ngModel"
                            [useGrouping]="true" [min]="policyDetails?.jobSiteOptionLimits?.jobSiteMinLimit" [disabled]="showProjectEdit || isBPMiFields?.ProjectLimit?.isShow" required
                            [ngClass]="{ 'is-invalid':  policy.submitted && !projectLimit.valid && projectLimit.status !='DISABLED'}" (onBlur)="onChangeProject()" (onInput)="ValidateProjectLimit($event)" mode="decimal" [maxFractionDigits]="5"></p-inputNumber>
                            <span  *ngIf="showProjectEdit" pTooltip="{{isBPMiFields?.ProjectLimit?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.ProjectLimit?.isShow ? 'editdisableIcls' : ''}}">
                            <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('projectID');showProjectEdit=false;"></i>
                        </span>
                        <span *ngIf="!showProjectEdit" class="{{isBPMiFields?.ProjectLimit?.isShow ? 'editdisableIcls' : ''}}">
                            <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoProjectLimit()"></i>
                        </span>
                        <br>
                        <div *ngIf="policy.submitted && !projectLimit.valid && projectLimit.status !='DISABLED'" class="invalid-feedback">
                            <div>Project Limit is required</div>
                        </div>
                        <div *ngIf="validateMinProject" class="error_msg">{{policyDetails?.jobSiteOptionLimits?.jobSiteMinLimitErrMsg}}</div>
                        <div *ngIf="validateMaxProject" class="error_msg">{{policyDetails?.jobSiteOptionLimits?.jobSiteMaxLimitErrMsg}}</div>
                        <div *ngIf="ProjectLimitValue < originalProjectLimit" class="error_msg">Project Limit cannot be decrease</div>
                        <span class="projectInfo_heading">{{ProjectLimitLabel}}</span><span class="projectInfo_value">${{projectLimitTotal}}</span>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-lg-12">
                        <label class="policyHeading">Deductible</label><br>
                        <p-dropdown [options]="DeductibleList" optionLabel="coverageLimit" optionValue="limitValue" name="deductible" class="stateDropdown padding_10 productinfo {{showdeductibleEdit?'disableControl':''}}" placeholder="Select Deductible" [style]="{width: '70% !important'}"
                        [ngClass]="{ 'is-invalid': policy.submitted && !deductible.valid && deductible.status !='DISABLED' }" [(ngModel)]="deductibleValue" #deductible="ngModel" (onChange)="onChangeDropdown('DED')"
                        [disabled]="showdeductibleEdit || isBPMiFields?.Deductible?.isShow" required inputId="deductibleID" optionDisabled="isDisabled"></p-dropdown>
                        <span *ngIf="showdeductibleEdit" pTooltip="{{isBPMiFields?.Deductible?.isShow ? 'Pending BFM action' : ''}}"  class="{{isBPMiFields?.Deductible?.isShow ? 'editdisableIcls' : ''}}">
                            <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('deductibleID');showdeductibleEdit=false;"></i>
                        </span>
                        <span *ngIf="!showdeductibleEdit" class="{{isBPMiFields?.Deductible?.isShow ? 'editdisableIcls' : ''}}">
                            <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoDeductibleLimit()"></i>
                        </span>
                        <div *ngIf="policy.submitted && !deductible.valid && deductible.status !='DISABLED'" class="invalid-feedback">
                            <div>Deductible is required</div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2" *ngIf="policyDetails?.policyDetails?.flood?.limit != 0">
                    <div class="col-lg-12">
                        <label class="policyHeading">Flood Limit</label>
                        <p-dropdown [options]="FloodList" name="floodLimit" optionLabel="coverageLimit" optionValue="limitValue" class="stateDropdown productinfo {{showFloodEdit?'disableControl':''}}" placeholder="Select Flood Limit" [style]="{width: '70% !important'}"
                        [ngClass]="{ 'is-invalid': policy.submitted && !flood.valid && flood.status !='DISABLED' }"
                        [(ngModel)]="floodValue" #flood="ngModel" required (onChange)="onChangeDropdown('LMT_EXPOS')" optionDisabled="disabled"
                        [disabled]="showFloodEdit || isBPMiFields?.FloodLimit?.isShow" inputId="floodID"></p-dropdown>
                        <span *ngIf="showFloodEdit" pTooltip="{{isBPMiFields?.FloodLimit?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.FloodLimit?.isShow ? 'editdisableIcls' : ''}}">
                            <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('floodID');showFloodEdit=false;"></i>
                        </span>
                        <span *ngIf="!showFloodEdit"  class="{{isBPMiFields?.FloodLimit?.isShow ? 'editdisableIcls' : ''}}">
                            <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoFloodLimit()"></i>
                        </span>
                        <div *ngIf="policy.submitted && !flood.valid && flood.status !='DISABLED'" class="invalid-feedback">
                            <div>Flood Limit is required</div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2" *ngIf="policyDetails?.policyDetails?.earthQuake?.limit != 0">
                    <div class="col-lg-12">
                        <label class="policyHeading">Earthquake Limit</label>
                        <p-dropdown [options]="EQList" name="Earthquake" optionLabel="coverageLimit" optionValue="limitValue" class="stateDropdown productinfo {{showEQEdit?'disableControl':''}}" placeholder="Select Earthquake Limit" [style]="{width: '70% !important'}"
                        [ngClass]="{ 'is-invalid': policy.submitted && !EQ.valid && EQ.status !='DISABLED' }" inputId="EQID"
                        [(ngModel)]="EQValue" #EQ="ngModel" required (onChange)="onChangeDropdown('LMT_EXPOS')" optionDisabled="disabled"
                        [disabled]="showEQEdit || isBPMiFields?.EarthQuakeLimit?.isShow"></p-dropdown>
                        <span *ngIf="showEQEdit" pTooltip="{{isBPMiFields?.EarthQuakeLimit?.isShow ? 'Pending BFM action' : ''}}" class="{{isBPMiFields?.EarthQuakeLimit?.isShow ? 'editdisableIcls' : ''}}">
                            <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('EQID');showEQEdit=false;"></i>
                        </span>
                        <span *ngIf="!showEQEdit"  class="{{isBPMiFields?.EarthQuakeLimit?.isShow ? 'editdisableIcls' : ''}}">
                            <i class="fa fa-undo mousePointer" title="Undo" style="color:rgb(0 87 120);font-size: 1.5rem;
                                margin-left: 10px;" (click)="UndoEQLimit()"></i>
                        </span>
                        <div *ngIf="policy.submitted && !EQ.valid && EQ.status !='DISABLED'" class="invalid-feedback">
                            <div>Earthquake Limit is required</div>
                        </div>
                    </div>
                </div>
                <!-- <p-toast key="c"></p-toast> -->
            </div>
            <div class="form-group mt-2">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group" style="margin-top: 1.7rem;
                        float: right;">
                            <button class="SubmitBtn" [disabled]="validateLimits()">Calculate Change</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </p-dialog>
    <p-dialog header="Extend Policy Term - {{policyChangeModal?.policyNumber}}" #eff (onHide)="editQuestion=false;"
    styleClass="EditExtendTerm MailingPopUp extendpolicy" [(visible)]="editQuestion" [modal]="true"
    [style]="{width: '50% !important'}" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
        [closable]="true">
        <div class="">
            <div class="row mt-2">
                <div class="col-lg-12">
                    <label class="policyHeading" style="width: 100% !important;">Please answer the following question in order to continue.<br/>
                        <div class="row col-lg-12 col-12 mb-2 mt-3">
                            <span style="margin-top: 3px;"
                              class="policyHeading">Do
                              any of the following apply?</span>                          
                        </div>
                    </label>
                    <label class="policyHeading">* Full funding of this project is not currently in place.<br/>
                    * There has been a change in General contractor during this project.<br/>
                    * There has been significant change from the original scope of work.<br/>
                    * Jobsite is currently dormant with no active work happening<br/>
                    * The property has been accepted by the owner</label>
                </div>
                
                    <div class="col-lg-12 col-12" *ngIf="isExtendPolicies == 'Yes'">
                      <label class="policyHeading" style="color:red;margin-left: 2px;"> Due to one or more exposures indicated, this policy is not eligible for
                       extension and the request is declined.</label><br>
                    </div>
                    <div class="col-lg-12 col-12"><div class="row"><div class="col-lg-8"><!--bindings={
                        "ng-reflect-ng-if": "false"
                      }--></div><div class="col-lg-2" style="margin-top: 0.7rem; float: right; text-align: right;">
                        <button class="SubmitBtn ng-star-inserted"  style="width: 5rem !important;" (click)="calculateOption('Yes')"  >Yes</button><!--bindings={
                        "ng-reflect-ng-if": "true"
                      }--><!--bindings={
                        "ng-reflect-ng-if": "false"
                      }--></div>
                      <div class="col-lg-2" style="margin-top: 0.7rem; float: right; text-align: right;">
                        <button class="SubmitBtn ng-star-inserted" style="width: 5rem !important;" (click)="calculateOption('No')">No</button><!--bindings={
                        "ng-reflect-ng-if": "true"
                      }--><!--bindings={
                        "ng-reflect-ng-if": "false"
                      }--></div>
                    </div>
                    </div>             
            </div>         
        </div>
    </p-dialog>
    <p-dialog header="Extend Policy Term - {{policyChangeModal?.policyNumber}}" #eff 
    styleClass="EditExtendTerm MailingPopUp extendpolicy" [(visible)]="closeEffective" [modal]="true"
    [style]="{width: '50% !important'}" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
        [closable]="true">
        <div class="">
            <div class="row mt-2">
                <div class="col-lg-12 form-inline">
                    <label class="policyHeading" style="color:red;margin-left: 2px;"> Due to one or more exposures indicated, this policy is not eligible for
                        extension and the request is declined.</label><br>                   
                </div>
                <div class="col-lg-12 col-12"><div class="row"><div class="col-lg-8"><!--bindings={
                    "ng-reflect-ng-if": "false"
                  }--></div><div class="col-lg-4" style="margin-top: 0.7rem; float: right; text-align: right;">
                    <button class="SubmitBtn ng-star-inserted" (click)="closePopUpConfirmation();" >Continue</button><!--bindings={
                    "ng-reflect-ng-if": "true"
                  }--><!--bindings={
                    "ng-reflect-ng-if": "false"
                  }--></div>
                </div>
                </div>

            </div>
        </div>
     </p-dialog>
    <p-dialog header="Extend Policy Term - {{policyChangeModal?.policyNumber}}" #eff 
    styleClass="EditExtendTerm MailingPopUp extendpolicy" [(visible)]="editEffective" [modal]="true"
    [style]="{width: '50% !important'}" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
        [closable]="true">
        <div class="">
            <div class="row mt-2">
                <div class="col-lg-12 form-inline">
                    <label class="policyHeading">Current effective date:</label>
                    <label class="effective_value"> {{effectiveDate}}</label>
                </div>
            </div>
        </div>
        <div class="">
            <div class="row mt-2">
                <div class="col-lg-12 form-inline">
                    <label class="policyHeading">Current expiration date:</label>
                    <label class="expiration_value"> {{tempExpirationDate}}</label>
                </div>
            </div>
        </div>
        <div class="mt-2">
            <div class="row">
                <div class="col-lg-12 form-inline">
                    <label class="policyHeading">Revised expiration date:</label>
                    <p-calendar name="expirationDate" class="zipCode"  monthNavigator="true" yearNavigator="true" [yearRange]="year+':'+maxyear"
                        [(ngModel)]="expirationDate" placeholder="Enter Expiration Date" [showIcon]="true" [minDate]="currentExpirationDate" selectOtherMonths="true"
                        [maxDate]="MaxExpirationDate" [style]="{'margin-left': '1.6rem'}" [disabled]="showExpiration || isBPMiFields?.ExpirationDate?.isShow || IsPolicyPeriodExtensionReached"
                        (onShow)="setActiveYear()" (onViewDateChange)="setActiveYear()" (onPanelChange)="setActiveYear()" (onSelect)="ValidateExtensionPeriod()"></p-calendar>
                    <span *ngIf="showExpiration && !isBPMiFields?.ExpirationDate?.isShow && !IsPolicyPeriodExtensionReached">
                        <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="showExpiration=false;"></i>
                    </span>
                    <span *ngIf="!showExpiration && !isBPMiFields?.ExpirationDate?.isShow && !IsPolicyPeriodExtensionReached">
                        <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoExpirationDate()"></i>
                    </span>
                    <div *ngIf="IsExceedExtentioPeriod || IsPolicyPeriodExtensionReached" class="error_msg">
                        The extension exceeds our online servicing standards.  Please refer this request to your underwriter.
                    </div>
                     <!-- <div *ngIf="EffectiveSubmitted && e.expirationDate.errors" class="invalid-feedback">
                        
                                <div *ngIf="e.expirationDate.errors.required">Expiration Date is required</div>
                            </div> -->
                </div>
            </div>
        </div>
        <div class="row mt-2" *ngIf="!ExtendPolicyPriorEffectiveDate">
            <div class="checkbox m-0">
                <input name="isConfirmBPMi" type='checkbox' id="isConfirmBPMiID" [checked]="isConfirmBPMi" [(ngModel)]="isConfirmBPMiChange"
                (change)="isConfirmBPMi = !isConfirmBPMi" />
                <label name="isConfirmBPMi_lbl" style="font-size: 15px;color: black;font-style: italic;" id="isConfirmBPMilbl" for="isConfirmBPMiID">
                I, as the undersigned representative of the named insured, agree that the insured has no knowledge of any pending claim, loss, or any circumstances based upon which it would be reasonable to conclude that a claim may result.
                </label>
            </div>
        </div>
        <div class="" style="margin-top: 15px;">
            <div class="row mt-2">
                <div class="col-lg-12">
                    <label><i>Berkley Fire & Marine recommends using a conservative completion
                        date, as only a <b>one-time extension</b> is allowed. Please ensure the extension period is between 90 and 365 days from the current expiration date. 
                        Additionally, the total policy term must not exceed 2 years from the current effective date.
                    </i></label>       
                </div>
            </div>
        </div>
        <div class="mt-2">
            <div class="row">
                <div class="col-lg-8">
                    <span *ngIf="!ExtendPolicyPriorEffectiveDate" style="color:red;font-size: 14px;">Extension for policies effective prior to 12/1/2021 require manual processing.</span>
                </div>
                <div class="col-lg-4" style="margin-top: 0.7rem;float: right;text-align: right;">
                    <button *ngIf="ExtendPolicyPriorEffectiveDate" class="SubmitBtn" (click)="calculateChange();" [disabled]="(tempExpirationDate==expirationDate || expirationDate == null || IsExceedExtentioPeriod)">Calculate Change</button>
                    <button *ngIf="!ExtendPolicyPriorEffectiveDate" class="SubmitBtn" (click)="calculateChange();" [disabled]="!(tempExpirationDate!=expirationDate && isConfirmBPMi)">Submit Request</button>
                </div>
            </div>
        </div>       
    </p-dialog>
    <p-dialog
        header="Error Notification" [(visible)]="showPolicyLockPopup"
        [modal]="true" [closable]="true"
        [draggable]="false" [resizable]="false"
        [style]="{ width: '500px' }">

        <div class="popup-message">
            <span [innerHTML]="policyLockMessage"></span>
        </div>

        <div class="text-center mt-3">
            <button
                class="policyCloseBtn"
                (click)="closePolicyLockPopup()">
                OK
            </button>
        </div>

    </p-dialog>
    <p-dialog header="Premium Adjustment" (onHide)="showPremium=false;"
        styleClass="PremiumPopUp dialo_popup" [(visible)]="showPremium" [modal]="true"
        [style]="{width: '50vw !important'}" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
        [closable]="true">
        <div class="row mt-2" *ngIf="!showBar">
            <div class="col-lg-12 form-inline p-0">
                <div class="col-lg-6 text-left">
                    <label style="float: left;" class="policyHeading">New Annual Premium:</label>
                    <label class="ml-2" style="float: left;">{{premiumValue}}</label>
                </div>
                
            </div>
        </div>
        <div class="row mt-2" *ngIf="amendPremiumValue != null && amendPremiumValue != '0' && amendPremiumValue != '0.00'">
            <div class="col-lg-12 form-inline p-0">
                <div class="col-lg-6 text-left">
                    <label style="float: left;" class="policyHeading">{{checkPositiveAmendPremium() ? 'Additional' : 'Return'}} Premium:</label>
                    <label class="ml-2" style="float: left;">{{amendPremiumValue}}</label>
                </div>                
                            
            </div>
        </div>
        <div class="row mt-2" *ngIf="amendPremiumValue == null || amendPremiumValue == '0' || amendPremiumValue == '0.00'">
            <div class="col-lg-12 form-inline p-0">
                <div class="col-lg-6">
                    <label style="color: red;font-size: 15px;font-weight: 400;float: left;">No premium change. </label>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="checkbox m-0">
                <input name="isConfirmBPMi" type='checkbox' id="isConfirmBPMiID" [checked]="isConfirmBPMi" [(ngModel)]="isConfirmBPMiChange"
                (change)="isConfirmBPMi = !isConfirmBPMi" />
                <label name="isConfirmBPMi_lbl" style="font-size: 15px;color: black;font-style: italic;" id="isConfirmBPMilbl" for="isConfirmBPMiID">
                I, as the undersigned representative of the named insured, agree that the insured has no knowledge of any pending claim, loss, or any circumstances based upon which it would be reasonable to conclude that a claim may result.
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 text-right">
                <button class="policyCloseBtn mr-2" (click)="showPremium=false;">Cancel</button>
                <button [disabled]="!isConfirmBPMiChange" style="width: 8rem !important;" class="premiumSubmitBtn"(click)="PremiumSubmit();">Submit Change</button>
            </div>
        </div>
        <div class="row mt-2 mb-0">
            <div class="col-lg-12">
                <span class="projectInfo_text">*By clicking Submit Change you are amending the policy information</span>
            </div>
        </div>
    </p-dialog>
    <p-dialog header="Edit Blanket Additional Insured - {{policyChangeModal?.policyNumber}}" [(visible)]="BlanketInfo.showBlanket" 
    (onHide)="closeBlanketAI();" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
    [closable]="true" [modal]="true" styleClass="EditMailingPopUp MailingPopUp">
        <div class="row mt-2">
            <div class="col-lg-12">
                <label class="policyHeading">Blanket Additional Insured</label><br>
                <p-dropdown [options]="BlanketInfo.blanketList" optionLabel="text" optionValue="code" name="blanketAI" class="stateDropdown padding_10 productinfo {{BlanketInfo.showBlanketAIEdit?'disableControl':''}}" placeholder="Select Blanket AI" [style]="{width: '70% !important'}"
                [(ngModel)]="BlanketInfo.blanketAI" inputId="BlanketID" [disabled]="BlanketInfo.showBlanketAIEdit || isBPMiFields?.BlanketInsured?.isShow" required></p-dropdown>
                <span *ngIf="BlanketInfo.showBlanketAIEdit && !isBPMiFields?.BlanketInsured?.isShow">
                    <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="AIEdit()"></i>
                </span>
                <span *ngIf="!BlanketInfo.showBlanketAIEdit && !isBPMiFields?.BlanketInsured?.isShow">
                    <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoBlanketAI()"></i>
                </span>
            </div>
        </div>
        <!-- <div class="color-box space">
                <div class="info-tab tip-icon" title="Useful Tips"><i></i></div>
                <div class="tip-box">
                    <p><strong>Info:</strong>*By clicking Submit Change you are amending the policy information</p>
                </div>
        </div> -->
        <div class="row mt-2">
            <div class="checkbox m-0">
                <input name="isConfirmBPMi" type='checkbox' id="isConfirmBPMiID" [checked]="isConfirmBPMi" [(ngModel)]="isConfirmBPMiChange"
                (change)="isConfirmBPMi = !isConfirmBPMi" />
                <label name="isConfirmBPMi_lbl" style="font-size: 15px;color: black;font-style: italic;" id="isConfirmBPMilbl" for="isConfirmBPMiID">
                I, as the undersigned representative of the named insured, agree that the insured has no knowledge of any pending claim, loss, or any circumstances based upon which it would be reasonable to conclude that a claim may result.
                </label>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-lg-12 text-right">
                <button class="SubmitBtn" (click)="UpdateBlanketAI()" [disabled]="!isConfirmBPMiChange || BlanketInfo.blanketAI==BlanketInfo.tempBlanketValue">Submit Change</button>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <span class="projectInfo_text">*By clicking Submit Change you are amending the policy information</span>
            </div>
        </div>
    </p-dialog>
    <p-dialog header="Policy Change Confirmation" [(visible)]="showPolicyConfirm" 
    (onHide)="closeConfirmation();" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
    [closable]="true" [modal]="true" styleClass="EditMailingPopUp MailingPopUp">
        <div class="row mt-2">
            <div class="col-lg-12">
                <span *ngIf="ExtendPolicyPriorEffectiveDate" class="confirmTxt">{{isBPMiAmend ? 'Your change has been submitted and will be completed by a Berkley Fire Marine specialist. The change item will stay in orange as pending until completion of change. A confirmation will be emailed when change is finalized.' : 'Amendment complete, you will receive a copy of your change request.'}}</span>
                <span *ngIf="!ExtendPolicyPriorEffectiveDate" class="extendPriorDateLabel confirmTxt">Your request has been submitted for processing, the amendment will be sent within 1-2 business days. If you have questions please contact us at xpressrequest&#64;berkleymarine.com.</span>
            </div>
        </div>
        <div class="row float-right mt-3">
            <button class="policyCloseBtn" (click)="closeConfirmation()">Close</button>
        </div>
    </p-dialog>
    <p-dialog header="Confirmation" [(visible)]="showBPMIConfirmation" 
    (onHide)="showBPMIConfirmation = false" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
    [closable]="true" [modal]="true" styleClass="EditMailingPopUp MailingPopUp">
        <div class="row mt-2">
            <div class="col-lg-12">
                <span class="confirmTxt">Your change has been submitted and will be completed by a Berkley Fire Marine specialist. The change item will stay in orange as pending until completion of change. A confirmation will be emailed when change is finalized.</span>
            </div>
        </div>
        <div class="row float-right mt-3">
            <button class="policyCloseBtn" (click)="showBPMIConfirmation = false;">Close</button>
        </div>
    </p-dialog>
    <p-dialog header="Financial Interest" (onHide)="closeFinancialInterest()"
        styleClass="EditMailingPopUp" [(visible)]="ViewFinancial" [modal]="true" [style]="{width: '50vw !important'}"
        [baseZIndex]="1000" [draggable]="false" [resizable]="false" [closable]="true">
        <div class="form-group mb-0">
            <div *ngFor="let interest of policyDetails?.clientInfo?.financialInterest?.interestTypes" style="margin-top: 10px;">
                <div class="row {{(isBPMiFields['InsurableInterest'+interest?.interestID]?.isShow) ? 'bpmicls' : ''}}">
                    <div class="col-lg-1">
                        <i class="fa fa-university policyIcon"></i>
                    </div>
                    <div class="col-lg-8 col-8" style="font-weight: bold;">
                        {{interest?.interestType}}
                    </div>
                </div>
                <div class="row {{(isBPMiFields['InsurableInterest'+interest?.interestID]?.isShow) ? 'bpmicls' : ''}}" style="margin-left: 30px;margin-top: 5px;">
                    <div class="col-lg-1">
                        <i class="fa fa-user policyAddressIcon"></i>
                    </div>
                    <div class="col-lg-8 col-8">
                        {{interest?.businessName}}
                    </div>
                </div>
                <div class="row" style="margin-left: 30px;margin-top: 5px;border-bottom: 1px solid #efefef;padding-bottom: 10px;" *ngFor="let address of interest?.addressInfo">
                    <div class="col-md-12 row" >
                        <div class="col-lg-1">
                            <i class="fa fa-home policyAddressIcon"></i>
                        </div>
                        <div class="col-lg-9 {{(isBPMiFields['InsurableInterest'+interest?.interestID]?.isShow) ? 'bpmicls' : ''}}">
                            {{address?.addressNo}} {{address?.addressLine1}}, {{address?.addressLine2}} {{address?.city}}, {{address?.state}} {{address?.zip}}
                        </div>
                        <div class="col-lg-2 row">
                            <span pTooltip="{{(isBPMiFields['InsurableInterest'+interest?.interestID]?.isShow) ? 'Pending BFM action' : ''}}" class="row {{(isBPMiFields['InsurableInterest'+interest?.interestID]?.isShow) ? 'editdisableIcls' : ''}}">
                                <i *ngIf="!interest?.isDeleted" class="fa fa-trash-o mousePointer del_icon" title="Delete" (click)="deleteFinancialInterest(interest);"></i>
                                <i *ngIf="!interest?.isDeleted" style="margin-top: 3px;" class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="editFinancialInterest(interest);"></i>                                
                            </span>
                            <!-- <i title="Delete" style="margin-right: 10px;color: red;cursor: pointer;"  class="fa fa-trash-o"></i>
                            <i title="Edit" style="color: #1ca7f9;margin-top: 2px;cursor: pointer;" (click)="editFinancialInterest(interest)" class="fa fa-pencil-square-o"></i> -->
                        </div>
                    </div>
                </div>                
            </div>
            <div style="float:right" class="row">
                <a (click)="addFinancialInterest()" class="financialIntAddbtn">Click to add financial Interest</a>
            </div>
            <div style="float:right;margin-top: 15px;" class="col-lg-12">
                <div class="">
                    <button style="float: right;" name="ViewFinan" id="ViewFinanID" class="policyCloseBtn" (click)="ViewFinancial=false;"
                    type="button">{{policyRequestLabels?.closeBtn}}</button>
                </div>
            </div>
        </div>
    </p-dialog>
    <p-dialog header="{{isCreateFinancialInterest ? 'Add': 'Edit'}} financial interest - {{policyChangeModal?.policyNumber}}" (onHide)="closeEditFinancial()"
        styleClass="EditMailingPopUp" [(visible)]="EditFinancial" [modal]="true" [style]="{width: '50vw !important'}"
        [baseZIndex]="1000" [draggable]="false" [resizable]="false" [closable]="true">
        <form (ngSubmit)="submitFinancialInterest(financialIntform)" #financialIntform="ngForm">
            <div class="form-group">
                <div class="row" style="margin-top: 20px;">
                    <div class="col-lg-1">
                        <i class="fa fa-university policyIcon"></i>
                    </div>
                    <div class="col-lg-3">
                        <label class="policyHeading">Interest type:</label>
                    </div>
                    <div class="col-lg-8">
                        <div class="row">
                            <p-dropdown [options]="interestTypeList" optionLabel="text" optionValue="code" name="interestType" [ngModelOptions]="{standalone: true}" class="financialIntDropdown padding_10" 
                            placeholder="Interest Type" [style]="{width: '100% !important'}" #interestType="ngModel"
                            [ngClass]="{ 'is-invalid': (financialIntform.submitted && (financialEditModel.interestTypeCode == null || financialEditModel.interestTypeCode == '')) }"
                            [(ngModel)]="financialEditModel.interestTypeCode" [disabled]="showInterestType" required></p-dropdown>
                        </div>
                        <div *ngIf="financialIntform.submitted && (financialEditModel.interestTypeCode == null || financialEditModel.interestTypeCode == '')" style="margin-left: -15px;color: red;">
                            <div>Interest Type is required</div>
                        </div> 
                    </div>
                </div>
                <div class="row" style="margin-top: 20px;">
                    <div class="col-lg-1">
                        <i class="fa fa-user policyIcon"></i>
                    </div>
                    <div class="col-lg-3">
                        <label class="policyHeading">Business Name:</label>
                    </div>
                    <div class="col-lg-8">
                        <div class="row">
                            <input type="text" class="form-control financialAddress" [(ngModel)]="financialEditModel.businessName" id="businessName" required
                            [ngClass]="{ 'is-invalid': (financialIntform.submitted && (financialEditModel.businessName == null || financialEditModel.businessName == '')) }"
                            [ngModelOptions]="{standalone: true}" name="businessName" placeholder="Business Name" [disabled]="showBusinessName" #businessName="ngModel"/>
                            <span *ngIf="showBusinessName && !isCreateFinancialInterest">
                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="showBusinessName=!showBusinessName;"></i>
                            </span>
                            <span *ngIf="!showBusinessName && !isCreateFinancialInterest">
                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoInteretType('businessName')"></i>
                            </span>
                        </div>
                        <div *ngIf="financialIntform.submitted && (financialEditModel.businessName == null || financialEditModel.businessName == '')" style="margin-left: -15px;color: red;">
                            <div>Business Name is required</div>
                        </div>                         
                    </div>
                </div>
                <div class="row" style="margin-top: 20px;" *ngIf="financialEditModel.addressInfo && financialEditModel.addressInfo.length > 0">
                    <div class="col-lg-1">
                        <i class="fa fa-home policyIcon"></i>
                    </div>
                    <div class="col-lg-3">
                        <label class="policyHeading">Address:</label>
                    </div>
                    <div class="col-lg-8">
                        <!-- <div class="row">
                            <input type="text" class="form-control financialAddress" [(ngModel)]="financialEditModel.addressInfo[0].addressNo" id="addressNo"
                            [ngModelOptions]="{standalone: true}" name="FinaddressNo" placeholder="Street No" [disabled]="showInterestAddress" #FinaddressNo="ngModel"/>
                            <span *ngIf="showInterestAddress && !isCreateFinancialInterest">
                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="showInterestAddress=!showInterestAddress;"></i>
                            </span>
                            <span *ngIf="!showInterestAddress && !isCreateFinancialInterest">
                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoInteretType('addressInfo')"></i>
                            </span>
                        </div> -->
                        <div class="row" style="margin-top: 10px;">
                            <input type="text" class="form-control financialAddress" [(ngModel)]="financialEditModel.addressInfo[0].addressLine1" id="Finaddress1" required
                                [ngClass]="{ 'is-invalid': (financialIntform.submitted && (financialEditModel.addressInfo[0].addressLine1 == null || financialEditModel.addressInfo[0].addressLine1 == '')) }" name="Finaddress1" [disabled]="showInterestAddress"
                                #Finaddress1="ngModel" maxlength="40" placeholder="Address"/>
                            <span *ngIf="showInterestAddress && !isCreateFinancialInterest">
                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="showInterestAddress=!showInterestAddress;"></i>
                            </span>
                            <span *ngIf="!showInterestAddress && !isCreateFinancialInterest">
                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoInteretType('addressInfo')"></i>
                            </span>
                            <!-- <textarea name="Finaddress1" maxlength="40" class="form-control financialAddress" [ngModelOptions]="{standalone: true}"  [disabled]="showInterestAddress" [(ngModel)]="financialEditModel.addressInfo[0].addressLine1" 
                                placeholder="Enter Address" required #Finaddress1="ngModel"></textarea>                            -->
                        </div>
                        <div *ngIf="financialIntform.submitted && (financialEditModel.addressInfo[0].addressLine1 == null || financialEditModel.addressInfo[0].addressLine1 == '')" style="margin-left: -15px;color: red;">
                            <div>Address is required</div>
                        </div> 
                        <div class="row" style="margin-top:10px;">
                            <input type="text" class="form-control financialAddress" [(ngModel)]="financialEditModel.addressInfo[0].city" id="city" required
                            [ngClass]="{ 'is-invalid': (financialIntform.submitted && (financialEditModel.addressInfo[0].city == null || financialEditModel.addressInfo[0].city == '')) }"
                            [ngModelOptions]="{standalone: true}" name="Fincity" placeholder="City" [disabled]="showInterestAddress" #Fincity="ngModel"/>
                        </div>
                        <div *ngIf="financialIntform.submitted && (financialEditModel.addressInfo[0].city == null || financialEditModel.addressInfo[0].city == '')" style="margin-left: -15px;color: red;">
                            <div>City is required</div>
                        </div> 
                        <div class="row" style="margin-top:10px;">
                            <p-dropdown [options]="stateList" [(ngModel)]="financialEditModel.addressInfo[0].state" class="financialIntDropdown padding_10" [disabled]="showInterestAddress" [ngModelOptions]="{standalone: true}" 
                            [ngClass]="{ 'is-invalid': (financialIntform.submitted && (financialEditModel.addressInfo[0].state == null || financialEditModel.addressInfo[0].state == '')) }"
                            placeholder="State" [style]="{width: '100% !important'}" placeholder="State"></p-dropdown>
                        </div>
                        <div *ngIf="financialIntform.submitted && (financialEditModel.addressInfo[0].state == null || financialEditModel.addressInfo[0].state == '')" style="margin-left: -15px;color: red;">
                            <div>State is required</div>
                        </div> 
                        <div class="row" style="margin-top:10px;">
                            <p-inputNumber class="financialIntDropdown" placeholder="Zip" [ngModelOptions]="{standalone: true}"
                                [ngClass]="{ 'is-invalid': (financialIntform.submitted && (financialEditModel.addressInfo[0].zip == null || financialEditModel.addressInfo[0].zip == '')) }" 
                                name="FinZip" [maxlength]="5" [disabled]="showInterestAddress" [(ngModel)]="financialEditModel.addressInfo[0].zip"
                                [useGrouping]="false" #FinZip="ngModel"></p-inputNumber>
                        </div>
                        <div *ngIf="financialIntform.submitted && (financialEditModel.addressInfo[0].zip == null || financialEditModel.addressInfo[0].zip == '')" style="margin-left: -15px;color: red;">
                            <div>Zip is required</div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="checkbox m-0">
                        <input name="isConfirmBPMi" type='checkbox' id="isConfirmBPMiID" [checked]="isConfirmBPMi" [(ngModel)]="isConfirmBPMiChange"
                        (change)="isConfirmBPMi = !isConfirmBPMi" />
                        <label name="isConfirmBPMi_lbl" style="font-size: 15px;color: black;font-style: italic;" id="isConfirmBPMilbl" for="isConfirmBPMiID">
                        I, as the undersigned representative of the named insured, agree that the insured has no knowledge of any pending claim, loss, or any circumstances based upon which it would be reasonable to conclude that a claim may result.
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group" style="margin-top: 1.7rem;margin-bottom: 0;
                        float: right;">
                            <button [disabled]="!isConfirmBPMiChange || (diableFinancialSubmit() && !isCreateFinancialInterest)" type="submit" class="SubmitBtn">Submit Change</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </p-dialog>
    <p-dialog header="Edit Billing Address - {{policyChangeModal?.policyNumber}}" (onHide)="closeBillingAddress()"
        styleClass="EditMailingPopUp" [(visible)]="EditBilling" [modal]="true" [style]="{width: '50vw !important'}"
        [baseZIndex]="1000" [draggable]="false" [resizable]="false" [closable]="true">
        <form (ngSubmit)="UpdateBillingAddress();" #billingform="ngForm">
            <div class="form-group">
                <div class="row" style="margin-top: 10px;">
                    <div class="col-lg-3">
                        <label class="policyHeading">Address</label>
                    </div>
                    <div class="col-lg-9">
                        <!-- <div class="row">
                            <input type="text" class="form-control address_controls" [(ngModel)]="BillingAddressInfo.streetNo" id="BilladdressNo" required
                            [ngClass]="{ 'is-invalid': billingSubmit && !BilladdressNo.valid && !BillingEdit.showstreetNo && !isBPMiFields?.BillingAddress?.isShow }"
                            [ngModelOptions]="{standalone: true}" name="BilladdressNo" [disabled]="BillingEdit.showstreetNo || isBPMiFields?.BillingAddress?.isShow" #BilladdressNo="ngModel"/>
                            <span *ngIf="BillingEdit.showstreetNo && !isBPMiFields?.BillingAddress?.isShow">
                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="BillingEdit.showstreetNo=!BillingEdit.showstreetNo;"></i>
                            </span>
                            <span *ngIf="!BillingEdit.showstreetNo && !isBPMiFields?.BillingAddress?.isShow">
                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="undoBillingEdit('showstreetNo')"></i>
                            </span>
                        </div>
                        <div *ngIf="billingSubmit && (BillingAddressInfo.streetNo == '' || BillingAddressInfo.streetNo == null) && !BillingEdit.showstreetNo && !isBPMiFields?.BillingAddress?.isShow" style="margin-left: -15px;color: red;">
                            <div>Address no is required</div>
                        </div>   -->
                        <div class="row"  style="margin-top:10px;">
                            <!-- <textarea class="form-control address_controls" [(ngModel)]="BillingAddressInfo.address1"
                                [ngClass]="{ 'is-invalid': billingSubmit && !billAddress1.valid }" name="billAddress1" #billAddress1="ngModel"
                                placeholder="ADDRESS 40 CHARS OR LESS"></textarea> -->
                            <input type="text" class="form-control address_controls" [(ngModel)]="BillingAddressInfo.address1" id="billAddress1" required
                                [ngClass]="{ 'is-invalid': billingSubmit && !billAddress1.valid && !BillingEdit.showaddress1 && !isBPMiFields?.BillingAddress?.isShow }" name="billAddress1"
                                #billAddress1="ngModel" maxlength="40" [disabled]="BillingEdit.showaddress1 || isBPMiFields?.BillingAddress?.isShow" />
                                <span  *ngIf="BillingEdit.showaddress1 && !isBPMiFields?.BillingAddress?.isShow">
                                    <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('billAddress1');BillingEdit.showaddress1=false;"></i>
                                </span>
                                <span *ngIf="!BillingEdit.showaddress1 && !isBPMiFields?.BillingAddress?.isShow">
                                    <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="undoBillingEdit('address1')"></i>
                                </span>
                            <div *ngIf="billingSubmit && !billAddress1.valid && !BillingEdit.showaddress1 && !isBPMiFields?.BillingAddress?.isShow" class="invalid-feedback">
                                <div *ngIf="billAddress1.required">Address is required</div>
                            </div>
                        </div>
                        <div class="row" style="margin-top:10px;">
                            <input type="text" class="form-control address_controls" [(ngModel)]="BillingAddressInfo.city" #billCity="ngModel" name="billCity"
                                [ngClass]="{ 'is-invalid': billingSubmit && !billCity.valid && !BillingEdit.showcity && !isBPMiFields?.BillingAddress?.isShow }" placeholder="CITY"  [disabled]="BillingEdit.showcity || isBPMiFields?.BillingAddress?.isShow"/>
                            <span  *ngIf="BillingEdit.showcity && !isBPMiFields?.BillingAddress?.isShow">
                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('billCity');BillingEdit.showcity=false;"></i>
                            </span>
                            <span *ngIf="!BillingEdit.showcity && !isBPMiFields?.BillingAddress?.isShow">
                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="undoBillingEdit('city')"></i>
                            </span>
                            <div *ngIf="billingSubmit && !billCity.valid && !BillingEdit.showcity && !isBPMiFields?.BillingAddress?.isShow" class="invalid-feedback">
                                <div *ngIf="billCity.required">City is required</div>
                            </div>
                        </div>
                        <div class="row" style="margin-top:10px;">
                            <p-dropdown [options]="stateList" class="stateDropdown padding_10" [disabled]="BillingEdit.showstate || isBPMiFields?.BillingAddress?.isShow"
                            [ngClass]="{ 'is-invalid': billingSubmit && !billState.valid && !BillingEdit.showstate && !isBPMiFields?.BillingAddress?.isShow }" [(ngModel)]="BillingAddressInfo.state" name="billState" #billState="ngModel"
                            placeholder="STATE" [style]="{width: '100% !important'}"></p-dropdown>
                            <span  *ngIf="BillingEdit.showstate && !isBPMiFields?.BillingAddress?.isShow">
                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('billState');BillingEdit.showstate=false;"></i>
                            </span>
                            <span *ngIf="!BillingEdit.showstate && !isBPMiFields?.BillingAddress?.isShow">
                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="undoBillingEdit('state')"></i>
                            </span>
                            <div *ngIf="billingSubmit && !billState.valid && !BillingEdit.showstate && !isBPMiFields?.BillingAddress?.isShow" class="invalid-feedback">
                                <div *ngIf="billState.required">State is required</div>
                            </div>
                        </div>
                        <div class="row" style="margin-top:10px;">
                            <p-inputNumber class="zipCode_popup" placeholder="ZIP CODE" [disabled]="BillingEdit.showpostalCode || isBPMiFields?.BillingAddress?.isShow"
                                [ngClass]="{ 'is-invalid': billingSubmit && !billZip.valid && !BillingEdit.showpostalCode && !isBPMiFields?.BillingAddress?.isShow }" name="billZip" name="Zip1" #billZip="ngModel" [maxlength]="5" [(ngModel)]="BillingAddressInfo.postalCode"
                                [useGrouping]="false"></p-inputNumber>
                            <span  *ngIf="BillingEdit.showpostalCode && !isBPMiFields?.BillingAddress?.isShow">
                                <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="focus('billZip');BillingEdit.showpostalCode=false;"></i>
                            </span>
                            <span *ngIf="!BillingEdit.showpostalCode && !isBPMiFields?.BillingAddress?.isShow">
                                <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="undoBillingEdit('postalCode')"></i>
                            </span>
                            <div *ngIf="billingSubmit && !billZip.valid && !BillingEdit.showpostalCode && !isBPMiFields?.BillingAddress?.isShow" class="invalid-feedback">
                                <div *ngIf="billZip.required">Zip is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group" style="margin-top: 1.7rem;margin-bottom: 0;
                        float: right;">
                            <button [disabled]="diableBillingSubmit()" class="SubmitBtn">Submit Change</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </p-dialog>
    <p-dialog header="Edit Pay Plan - {{policyChangeModal?.policyNumber}}" [(visible)]="PayPlanInfo.showPayPlan" 
    (onHide)="closePayPlan();" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
    [closable]="true" [modal]="true" styleClass="EditMailingPopUp MailingPopUp payplanPopup">
        <div class="row mt-2">
            <div class="col-lg-12">
                <label class="policyHeading">Pay Plan</label><br>
                <p-dropdown [options]="PayPlanInfo.PayPlanList" optionLabel="text" optionValue="code" name="payPlan" class="stateDropdown padding_10 productinfo {{PayPlanInfo.showPayPlanEdit?'disableControl':''}}" placeholder="Select Pay Plan" [style]="{width: '70% !important'}"
                [(ngModel)]="PayPlanInfo.PayPlanCode" inputId="payPlanID" [disabled]="isBPMiFields?.BillingPayPlan?.isShow || PayPlanInfo.showPayPlanEdit" required></p-dropdown>
                <span *ngIf="PayPlanInfo.showPayPlanEdit && !isBPMiFields?.BillingPayPlan?.isShow">
                    <i class="fa fa-pencil-square-o mousePointer edit_icon" title="Edit" (click)="PayplanEdit()"></i>
                </span>
                <span *ngIf="!PayPlanInfo.showPayPlanEdit && !isBPMiFields?.BillingPayPlan?.isShow">
                    <i class="fa fa-undo mousePointer edit_icon" title="Undo" (click)="UndoPayPlan()"></i>
                </span>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-lg-12 text-right">
                <button class="SubmitBtn" (click)="UpdatePayplan()" [disabled]="PayPlanInfo.PayPlanCode==PayPlanInfo.tempPayPlanCode">Submit Change</button>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <span class="projectInfo_text">*By clicking Submit Change you are amending the policy information</span>
            </div>
        </div>
    </p-dialog>
</div>

<!-- <p-confirmDialog [style]="{width: '50vw'}" styleClass="confirmbtn" [baseZIndex]="1000" rejectButtonStyleClass="p-button-text"></p-confirmDialog> -->
<p-progressBar *ngIf="showBar" [value]="value"></p-progressBar>